export default function PHP_FileCreateWrite() {
  return (
    <div>
      <h1>PHP_FileCreateWrite</h1>
    </div>
  );
}
